import React from 'react';
import '../styles/mobile-components.css'; // Updated to reflect mobile-specific CSS

const renderArrayAsText = (input) => {
  if (!input) return null;
  if (Array.isArray(input)) {
    return input.map((item, index) => (
      <span key={index}>
        {item.trim()}
        <br />
      </span>
    ));
  }
  return input.split('\n').map((str, index) => (
    <span key={index}>
      {str.trim()}
      <br />
    </span>
  ));
};

const MobileResume = ({
  name,
  title,
  location,
  email,
  phone,
  summary,
  experience,
  skills,
  education,
  publications,
}) => {
  return (
    <div className="mobile-resume">
      <div className="mobile-resume-header">
        <h1>{name}</h1>
        <p>{title}</p>
        <p>{location} | {email} | {phone}</p>
      </div>
      <div className="mobile-resume-section">
        <h2 className="mobile-section-header">Summary</h2>
        <p className="mobile-resume-text">{renderArrayAsText(summary)}</p>
      </div>
      <div className="mobile-resume-section">
        <h2 className="mobile-section-header">Professional Experience</h2>
        <p className="mobile-resume-text">{renderArrayAsText(experience)}</p>
      </div>
      <div className="mobile-resume-section">
        <h2 className="mobile-section-header">Skills</h2>
        <p className="mobile-resume-text">{renderArrayAsText(skills)}</p>
      </div>
      <div className="mobile-resume-section">
        <h2 className="mobile-section-header">Education</h2>
        <p className="mobile-resume-text">{renderArrayAsText(education)}</p>
      </div>
      <div className="mobile-resume-section">
        <h2 className="mobile-section-header">Publications</h2>
        <p className="mobile-resume-text">{renderArrayAsText(publications)}</p>
      </div>
    </div>
  );
};

export default MobileResume;